<template>
  <div>
    <div class="container pt-4" >
      <form class="py-3" style="max-width: 500px;margin: 0 auto; padding:15px;">
        <h4 class="pb-4">更改密码</h4>
        <validation-observer ref="pwdChangeForm">


          <validation-provider
              :rules="validators.rules.oldPassword"
              :customMessages="validators.msgs.oldPassword"
              name="旧密码"
              v-slot="validationContext"
            >
            <b-form-group label="旧密码" :invalid-feedback="validationContext.errors[0]">
              <b-form-input 
                type="password"
                v-model="pwdChangeDto.oldPassword" 
                :state="validateState(validationContext)"
                placeholder="旧密码">
              </b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider
              :rules="validators.rules.newPassword"
              :customMessages="validators.msgs.newPassword"
              name="新密码"
              v-slot="validationContext"
              vid="newPassword1"
            >
            <b-form-group label="新密码" :invalid-feedback="validationContext.errors[0]">
              <b-form-input 
                type="password"
                v-model="pwdChangeDto.newPassword" 
                :state="validateState(validationContext)"
                placeholder="新密码">
              </b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider
              :rules="validators.rules.confirmPassword"
              :customMessages="validators.msgs.confirmPassword"
              name="确认密码"
              v-slot="validationContext"
            >
            <b-form-group label="确认密码" :invalid-feedback="validationContext.errors[0]">
              <b-form-input 
                type="password"
                v-model="pwdChangeDto.confirmPassword" 
                :state="validateState(validationContext)"
                placeholder="确认密码">
              </b-form-input>
            </b-form-group>
          </validation-provider>
        <b-button type="submit" variant="primary" @click="handleChangePassword" class="m-1">保存</b-button>

        </validation-observer>
      </form>

      </div>
  
  </div>
</template>

<script>
import * as userFacade from "../../../api/user-facade.js";
// import router from '../../../router';

export default {
  // validations:
  data() {
    return {
      pwdChangeDto: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      },

      // 错误提示
      validators: {
        rules: {
          oldPassword: {
            required: true,
            regex: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
          },
          newPassword: {
            required: true,
            regex: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
          },
          confirmPassword: {
            required: true,
            confirmed: "newPassword1"
          }
        },
        msgs: {
          oldPassword: {
            required: "旧密码不能为空",
            regex: "密码要求字母数字组合,6到20个字符"
          },
          newPassword: {
            required: "新密码不能为空",
            regex: "密码要求字母数字组合,6到20个字符"
          },
          confirmPassword: {
            required: "确认密码不能为空",
            confirmed: "确认密码不等于新密码"
          },
        }
      },
    };
  },

  created() {},
  mounted() {},
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    resetForm() {
      this.pwdChangeDto = {
        oldPassword: null,
        newPassword: null,
        confirmPassword: null
      };

      this.$nextTick(() => {
        this.$refs.pwdChangeForm.reset();
      });
    },

    handleChangePassword(){
      this.$refs.pwdChangeForm.validate().then(valid => {
        if (valid) {
          //let param = { captchaVerification: "11" };
          //this.handleLogin(param);
          // this.verifyVisible = true;
          userFacade
            .passwordChange(this.pwdChangeDto)
            .then(() => {
              this.$message({
                message: "更改用户密码成功,稍后请重新登录",
                type: "success"
              });

              // 更改成功后，返回重新登录
              let var1 = this;
              setTimeout(function() {
                var1.$router.replace("/login")
              }, 3000);

              this.resetForm();
            })
            .catch(err => {
              console.log("err", err);
            });

        } else {
          // 登录表单校验失败
          this.$message({
            message: "请填写正确的信息",
            type: "danger"
          });
        }
      });
    }
  }
};
</script>

<style >
</style>
